import React, { useState } from 'react';
import babaji from "./babaji.png";
import './style.css'
import ShriBghawan from "./ShriBghawan.png"
import Babaji1 from './Babaji1.png'
import Babaji2 from './Babaji2.png'

import Babaji6 from './Babaji6.png'
import Babaji8 from './88.png'
import Guruji from './99.png'
import ContactUs from "./ContactUs.js"


export default function About() {
    const [isButtonOn, setIsButtonOn] = useState(false);

    const toggleButton = () => {
      setIsButtonOn(!isButtonOn);
    };
  return (
    <>
    <div className='bg'>
    <div class={`toggle-button ${isButtonOn ? 'on' : 'off'}`} onClick={toggleButton}>
  <div className={`slider ${isButtonOn ? 'on' : 'off'}`} />
  <div className="button-text">
    {!isButtonOn ? 'Hindi' : 'English'}
  </div>
</div>
      </div>
      {isButtonOn ? (
          <div className='backgr'>
          <div>
            <p className='main-head'>
            <strong>गुरु परम्परा</strong>
            </p>
            <p>
    
            </p>
          </div>
          <div>
            <p className='main-head1'>
            <strong>आदिगुरु</strong>
            </p>
          </div>
      
          <div className="img-2">
          <img src={ShriBghawan} alt='ShriBghwan'/>
          </div>
          <div className='nme1'>
            <p>
आदिगुरु श्री कृष्ण</p>
          </div>
          <div className="para">
            <div className="style-p">
              <p className='head1'>
              <strong>भगवान् श्रीकृष्ण का वचन</strong>
              </p>
                <p className='othershl'>
                <strong>तपस्विभ्योऽधिको योगी ज्ञानिभ्योऽपि मतोऽधिकः।</strong>
                  
                </p>
                <p className='othershl'>
                <strong>कर्मिभ्यश्चाधिको योगी तस्माद्योगी भवार्जुन।।6.46।।</strong>
               
                </p>
                <p className='other'>
                "हमारे मत में योगी तपस्वी से श्रेष्ठ है; ज्ञानियों से भी श्रेष्ठ है; कर्म करने वालों से भी श्रेष्ठ है; अतएव, हे अर्जुन! तुम योगी हो जाओ।"
                </p>
            </div>
        </div>
          <div>
            <p className='main-head1'>
            <strong>परम परमेष्ठि गुरु</strong>
            </p>
          </div>
          <div className="image-container2">
          <img src={babaji} alt='Babaji'/>
          </div>
          <div className='nme'>
            <p>
            महामुनी
महावतार बाबाजी महाराज</p>
          </div>
          <div className="para">
            <div className="style-p">
              <p className='head1'>
              <strong>बाबाजी का वचन</strong>
              </p>
                <p className='othershl'>
                <strong>स्वल्पमप्यस्य धर्मस्य त्रायते महतो भयात् ॥ भगवद्गीता 2:40</strong>
                  
                </p>
                <p className='othercen'>
                “इस क्रियायोग रूप धर्म का थोड़ा-सा भी साधन मृत्यु रूपी महान भय से रक्षा करता है।
               
                </p>
                <p className='othercen'>
                “यह संसार रेत और चीनी का मिश्रण है। चींटी की भाँति चीनी को ग्रहण करो और रेत को छोड़ दो; अर्थात् जगत के असार तत्व को छोड़ सार तत्व को ग्रहण करो।”
               
                </p>
            </div>
        </div>
        <div>
            <p className='main-head1'>
            <strong>परमेष्ठि गुरु</strong>
            </p>
          </div>
          <div className="image-container2">
          <img src={Babaji1} alt='Babaji'/>
          </div>
          <div className='nme'>
            <p>
            योगिराज श्री श्यामचरण लाहिड़ी महाशय</p>
          </div>
          <div className="para">
            <div className="style-p">
              <p className='head1'>
              <strong>लाहिड़ी बाबा के मुख्य उपदेश</strong>
              </p>
                <p className='othershl'>
                <strong>प्राणो हि भगवानीशः प्राणो विष्णुपितामहः।</strong>
                  
                </p>
                <p className='othershl'>
                <strong>प्राणेन धार्यते लोकः सर्वं प्राणमयं जगत्॥
                 </strong>

                </p>
                <p className='other'>
                "प्राण की उपासना करो। प्राण ही भगवान् है, वही ब्रह्मा और विष्णु है। प्राण ही जगत् को धारण किए हुए है। समस्त ब्रह्मांड प्राणमय है। प्राण की सेवा से समस्त लौकिक और परलौकिक अभीष्ट प्राप्त हो जाते हैं।"
               
                </p>
                <p className='head1'>
              <strong>संक्षिप्त जीवनी</strong>
              </p>
                <p className='other'>
                श्री श्यामाचरण लाहिड़ी (30 सितंबर 1828 – 26 सितंबर 1895) जिन्हें आदर से भक्तगण लाहिड़ी बाबा के नाम से पुकारते हैं, 19वीं शताब्दी में क्रियायोग के प्रथम प्रवर्तक हैं। उनके गुरु महामुनि महावतार बाबाजी ने चमत्कारिक तरीके से उन्हें हिमालय में बुलाकर ‘क्रियायोग’ नामक प्राचीन योग विद्या प्रदान किया और योग्य मुमुक्षुजनों को क्रियायोग का उपदेश करने का आदेश दिया। भारतीय संतों व योगियों के मध्य उन्हें बड़ी श्रद्धा व आदर के साथ देखा जाता है; क्योंकि गृहस्थ होते हुए भी उन्होंने तुरियावस्था को प्राप्त किया था। वे ब्रिटिश शासन में अकाउंटेंट के पद पर कार्यरत थे। लाहिड़ी बाबा के प्रमुख शिष्य हुए: <br/>1. श्री पंचानन भट्टाचार्य (देवघर), 2. श्री महेंद्र चटर्जी (कोलकाता), 3. श्री कृष्णराम साठे (बनारस), 4. श्री तीनकौरी लाहिड़ी (श्री लाहिड़ी बाबा के प्रथम पुत्र), 5. श्री दुकौरी लाहिड़ी (लाहिड़ी बाबा के द्वितीय पुत्र), 6. श्रीमती काशीमणि देवशर्मन (लाहिड़ी बाबा की पत्नी), 7. श्री गुरुदास बनर्जी (चुंचुरा, बंगाल), 8. श्री चित्रसेन सिंह (फैजाबाद), 9. श्री कालीकृष्ण टैगोर (कोलकाता), 10. श्री आशुतोष चटर्जी (कोलकाता) 11. श्री प्रियनाथ कड़ार यानि स्वामी श्री श्रीयुक्तेश्वर गिरि (परमहंस योगानन्दजी के गुरु) 12. श्री ब्रिजलाल अधिकारी (बंगाल), 13. श्री प्रसाददास गोस्वामी (श्रीरामपुर), 14. श्री कालीकुमार बनर्जी (बंगलादेश), 15. श्री रामगोपाल मजूमदार (तारकेश्वर), 16. श्रीमती संध्यादास (कोलकाता), 17. श्री हरिनारायण पलोधी (बनारस), 18. श्री कालीकुमार राय (दानापुर), 19. श्री विजय चन्द्र (नवद्वीप), 20. श्री भूपेन्द्रनाथ सान्याल (भागलपुर), 21. श्री महादेव प्रसाद (बनारस), 22. श्री वृन्दा राम (बनारस), 23. श्री भगवती चरण घोष (परमहंस योगानन्द जी के पिता), 24. श्री आमिर अली (बनारस), 25. श्री अब्दुल गफ़्फ़ुर (सहारनपुर), 26. श्री गंगाधर बंदोपाध्याय (बनारस), 27. श्री मन्मथनाथ मुखर्जी यानि स्वामी प्रणवानन्द जी (हावड़ा), 28. श्री नील माधव (हावड़ा)

                </p>
            </div>
        </div>
        <div>
            <p className='main-head1'>
            <strong>परात्पर गुरु</strong>
            </p>
          </div>
          <div className="image-container2">
          <img src={Babaji2} alt='Tinkauri Lahiri Baba'/>
          </div>
          <div className='nme'>
            <p>
            तिनकौड़ी लाहिड़ी बाबा</p>
          </div>
          <div className="para">
            <div className="style-p">
            <p className='head1'>
              <strong>मुख्य उपदेश</strong>
              </p>
              <p className='othercen'>
               "साधना की दृष्टि से अपने को गुप्त रखो और क्षुद्र समझो।"
                </p>
            <p className='head1'>
              <strong>संक्षिप्त जीवनी</strong>
              </p>
                <p className='other'>
                श्री तीनकौरी लाहिड़ी, श्री श्यामाचरण लाहिड़ी बाबा के प्रथम पुत्र थे। वे एक सिद्ध क्रिया योगी
थे। अपने को बड़ा गोपन रखते थे। ‘पुराण पुरुष’ में उल्लेख है कि उन्होंने एक आसन पर 14 घंटे
क्रिया करके महावतार बाबाजी का दर्शन प्राप्त किया। पूर्ण चेतन अवस्था में उन्होंने योगबल से
अपने प्राण का त्याग किया था।
                </p>
            </div>
        </div>
        <div>
            <p className='main-head1'>
            <strong>परम गुरु</strong>
            </p>
          </div>
          <div className="image-container2">
          <img src={Babaji6} alt='Satyacharan Lahiri Baba'/>
          </div>
          <div className='nme'>
            <p>
            सत्यचरण लाहिड़ी बाबा</p>
          </div>
          <div className="para">
            <div className="style-p">
              <p className='head1'>
              <strong>मुख्य उपदेश</strong>
              </p>
                <p className='othercen'>
                "क्रिया साधना अखंड होनी चाहिए; अर्थात् साधना में निरंतरता होनी चाहिए। कुछ दिन क्रिया किया और कुछ दिन नहीं किया, ऐसा नहीं होना चाहिए।"
                  
                </p>
                <p className='head1'>
              <strong>संक्षिप्त जीवनी</strong>
              </p>
                <p className='other'>
                श्री सत्यचरण बाबा (28 जनवरी 1905 से 22 जनवरी 1987) श्री तीनकौरी लाहिड़ी के पुत्र अर्थात् श्री श्यामाचरण लाहिड़ी बाबा के प्रपौत्र थे। वे एक सिद्ध क्रिया योगी थे। वे सदा क्रिया की परावस्था में रहते थे। वे क्रिया दीक्षा के सम्बंध में पात्रता पर विशेष बल देते थे। किन्तु, यदि पात्र व्यक्ति हो तो वे उसका जाति-धर्म नहीं देखते थे और दीक्षा दे देते थे। ‘पुराण पुरुष’ की रचना में उनका विशेष योगदान था। वे भी अपने पिता की भाँति पूर्ण चेतन अवस्था में योगबल से अपने प्राण का त्याग किया था।
               
                </p>
            </div>
        </div>
        <div>
            <p className='main-head1'>
            <strong>स्व गुरु</strong>
            </p>
          </div>
          <div className="image-container2">
          <img src={Babaji8} alt='Shree Shyambihari Ji Maharaj'/>
          </div>
          <div className='nme'>
            <p>
            श्री श्याम बिहारी जी महाराज</p>
          </div>
          <div className="para">
            <div className="style-p">
            <p className='head1'>
              <strong>संक्षिप्त जीवनी</strong>
              </p>
                <p className='other'>
                 आपका जन्म 29 सितंबर 1947 को बिहार के रोहतास जिले में क्षत्रिये कुल में हुआ है। बचपन से ही अध्यात्म में विशेष रुचि थी। इनकी दादी बड़ी धार्मिक प्रकृति की थी। एक माह पूर्व ही अपने मृत्यु का भान होने पर वे आत्म-मोक्षार्थ निःस्पृह भाव से घर छोड़ कर काशी के लिए चल पड़ी। परिवार के सभी सदस्यों को साथ आने से मना कर दिया और पूर्वकथित तिथि पर देह त्याग किया। इनके पिताजी भी गुप्त रूप से  योग साधना करते थे। इस प्रकार आध्यात्मिक वातावरण इनको विरासत में मिली है। किशोरावस्था में ही इन्होंने अनेक उपनिषद् एवं योग सम्बन्धी ग्रन्थों को अध्ययन किया। 
वे बिहार सरकार में विजिलेन्स ऑफिसर के पद पर कार्यरत थे। सम्पूर्ण जीवन भर वे एक ईमानदार और सिद्धांतवादी व्यक्ति रहे हैं। यही कारण है कि पदेन लोलुपता व अवसरवादिता से सर्वथा परे अपने आध्यात्मिक साधन में लगे रहे हैं। आध्यात्मिक विकास एवं गुरु प्राप्ति हेतु इन्होंने माँ काली की वर्षों उपासना की। काशी के अघोर पंथ के बाबा किनाराम की परम्परा के औघर बाबा राम जो आपके फुफेरे भाई थे, उन्होंने कहा, “काशी में ही तुम्हें गुरु की प्राप्ति होगी।” तत्पश्चात्  गुरु पुर्णिमा से पूर्व सन 1984 में उन्होंने श्री लाहिड़ी बाबा के प्रपौत्र श्री सत्यचरण लाहिड़ी से दीक्षा प्राप्त की। अपने गहन साधना के फलस्वरूप केवल 2 वर्षों में ही गुरु से छहों क्रिया प्राप्त कर ली।
               
                </p>
            </div>
        </div>
        <div>
            <p className='main-head1'>
            <strong>क्रिया गुरु</strong>
            </p>
          </div>
          <div className="image-container2">
          <img src={Guruji} alt='Acharya Shri Dharmendra Ji Maharaj'/>
          </div>
          <div className='nme'>
            <p>
            आचार्य श्री धर्मेन्द्र जी महाराज</p>
          </div>
          <div className="para">
            <div className="style-p">
            <p className='head1'>
              <strong>मुख्य उपदेश</strong>
              </p>
                <p className='other'>
                "पूर्णत्व ही योग है।"
                  
                </p>
            </div>
        </div>
        </div>
        ) : (
          <div className='backgr'>
          <div>
            <p className='main-head'>
            <strong> Kriya Yoga Lineage</strong>
            </p>
            <p>
    
            </p>
          </div>
          <div>
            <p className='main-head1'>
            <strong>Adiguru</strong>
            </p>
          </div>
      
          <div className="img-2">
          <img src={ShriBghawan} alt='Shri Bhagwan'/>
          </div>
          <div className='nme1'>
            <p>
Adiguru Shree Krishna</p>
          </div>
          <div className="para">
            <div className="style-p">
              <p className='head1'>
              <strong>Gospel of Lord Krishna</strong>
              </p>
                <p className='othershl'>
                <strong>तपस्विभ्योऽधिको योगी ज्ञानिभ्योऽपि मतोऽधिकः।</strong>  
                </p>
                <p className='othershl'>
                <strong>कर्मिभ्यश्चाधिको योगी तस्माद्योगी भवार्जुन।।6.46।।</strong>
                </p>
                <p className='othershl'>
                <strong>tapasvibhyo ’dhiko yogi jñānibhyo ’pi mato ’dhikaḥ.</strong>  
                </p>
                <p className='othershl'>
                <strong>karmibhyaśhchādhiko yogi tasmād yogī bhavārjuna</strong>
                </p>
                <p className='other'>
                "The yogi is deemed greater than body-disciplining ascetics, greater even than the followers of the path of wisdom or of the path of action; be thou, O Arjuna, a yogi!"
                </p>
            </div>
        </div>
          <div>
            <p className='main-head1'>
            <strong>Param Parmeshti Guru</strong>
            </p>
          </div>
          <div className="image-container2">
          <img src={babaji} alt='Babaji'/>
          </div>
          <div className='nme'>
            <p>
            Mahamuni
Mahavtar Babaji Maharaj</p>
          </div>
          <div className="para">
            <div className="style-p">
              <p className='head1'>
              <strong>Foremost preaching of Babaji</strong>
              </p>
                <p className='othershl'>
                <strong>स्वल्पमप्यस्य धर्मस्य त्रायते महतो भयात् ॥ भगवद्गीता 2:40</strong>
                  
                </p>
                <p className='othercen'>
                 “Even a tiny bit of real religion protects from great fear (the colossal sufferings) inherent in the repeated cycles of birth and death”
               
                </p>
                <p className='othercen'>
                Everything on this earth is of a mixed character like mingling of sand and suger. Be like the wise ant which seizes only the sugar and leaves the sand untouched. That is, receive the essence of the world and leave the worthless ones.
               
                </p>
            </div>
        </div>
        <div>
            <p className='main-head1'>
            <strong>Parmeshti Guru</strong>
            </p>
          </div>
          <div className="image-container2">
          <img src={Babaji1} alt='Babaji'/>
          </div>
          <div className='nme'>
            <p>
            Yogiraj Shree Shyamcharan Lahiri Mahashay</p>
          </div>
          <div className="para">
            <div className="style-p">
              <p className='head1'>
              <strong>Foremost preaching of Lahiri Baba</strong>
              </p>
                <p className='othershl'>
                <strong>प्राणो हि भगवानीशः प्राणो विष्णुपितामहः।</strong>
                  
                </p>
                <p className='othershl'>
                <strong>प्राणेन धार्यते लोकः सर्वं प्राणमयं जगत्॥
                 </strong>

                </p>
                <p className='other'>
                 "Do service to Prana. Prana is omnipresent and omnipotent. Because Prana is God, it is Brahma and Vishnu. Prana has sustained the universe. The whole cosmos is pervaded by Prana. One can achieve everything either material or spiritual by adoration of Prana."
               
                </p>
                <p className='head1'>
              <strong>Brief Life Sketch</strong>
              </p>
                <p className='other'>
                Shyama Charan Lahiri (30 September 1828 – 26 September 1895), best known as Lahiri Baba, was the first begetter of Kriya Yoga. In December 1868, his master, Mahavatar Babaji miraculously called him to the Himalayas and empowered him to revive the ancient yogic science of Kriya Yoga and teach it to the true seeker. He was an "Ideal yogi-householder" unusual among Indian holy people working as an accountant in British Government. He became known in the West through Paramahansa Yogananda, a disciple of Swami Sriyukteswar Giri (direct disciple of Lahiri Baba) and through Yogananda's 1946 book Autobiography of a Yogi, considering him a Yogavatar, or "Incarnation of Yoga", since Lahiri Baba himself was chosen by the yogic masters to disseminate the principles of yoga to the world.
                </p>
            </div>
        </div>
        <div>
            <p className='main-head1'>
            <strong>Paratpar Guru</strong>
            </p>
          </div>
          <div className="image-container2">
          <img src={Babaji2} alt='Tinkauri Lahiri Baba'/>
          </div>
          <div className='nme'>
            <p>
            Tinkauri Lahiri Baba</p>
          </div>
          <div className="para">
            <div className="style-p">
            <p className='head1'>
              <strong>Foremost preaching</strong>
              </p>
              <p className='othercen'>
                <strong>"Hide your spiritual gesture and be humble"</strong>
                </p>
            <p className='head1'>
              <strong>Brief Life Sketch</strong>
              </p>
                <p className='other'>
                Shri Tinkauri Lahiri was the first son of Shri Shyamacharan Lahiri Baba. He was a Siddha Kriya Yogi. He used to keep his spiritual stature hidden from the eyes of common people. It is mentioned in 'Purana Purush' that he sitting in one posture performing 14 hours Kriya practice, had an opportunity to see Mahavatar Babaji.  he left his body with the power of Yoga in a fully conscious state.
                </p>
            </div>
        </div>
        <div>
            <p className='main-head1'>
            <strong>Param Guru</strong>
            </p>
          </div>
          <div className="image-container2">
          <img src={Babaji6} alt='Satyacharan Lahiri Baba'/>
          </div>
          <div className='nme'>
            <p>
            Satyacharan Lahiri Baba</p>
          </div>
          <div className="para">
            <div className="style-p">
              <p className='head1'>
              <strong>Foremost preaching</strong>
              </p>
                <p className='othercen'>
                <strong>"Kriya Sadhana should be unbroken; That means there should be continuity in Yoga practice. we start Kriya-practice and continue for some days and left practicing for a few days, again we start. This interruption in Yoga practice is not appreciable."</strong>
                  
                </p>
                <p className='head1'>
              <strong>Brief Life Sketch</strong>
              </p>
                <p className='other'>
Shri Satyacharan Baba (28 January 1905 to 22 January 1987) was the son of Shri Tinkauri Lahiri i.e. the great-grandson of Shri Shyamacharan Lahiri Baba. He was a Siddha Kriya Yogi. He always remained in the state of super-consciousness. In relation to Kriya Diksha, He used to have a keen observance for eligibility.  But, if he found a person eligible, he did not see his caste-religion and just gave initiation. He had a special contribution in writing 'Purana Purush'. Like his father, he left his body with the power of Yoga in a fully conscious state.
               
                </p>
            </div>
        </div>
        <div>
            <p className='main-head1'>
            <strong>Swa Guru</strong>
            </p>
          </div>
          <div className="image-container2">
          <img src={Babaji8} alt='Shree Shyambihari Ji Maharaj'/>
          </div>
          <div className='nme'>
            <p>
            Shree Shyam Bihari Ji Maharaj</p>
          </div>
          <div className="para">
            <div className="style-p">
            <p className='head1'>
              <strong>Brief Life Sketch</strong>
              </p>
                <p className='other'>
                He is born in Kshatriy family on 29th September 1947 in Rahtas district of Bihar. He has a keen interest in spiritualism since childhood. His grand-mother also had a religious nature. One month earlier on the premonition of her death, she detached herself from the family bondage and left for Kashi for self-liberation. She stopped the family members to come along and left the body on the aforesaid date in Kashi. His father also used to practice yoga secretly. In this way, he has inherited the spiritual environment. In his adolescence, he studied many Upanishads and Yoga related books.
He was working as Vigilance Officer in the Government of Bihar. Throughout his life, he has been an honest and principled person. That’s why far from greediness and opportunism of Govt. post, he has been engaged in his spiritual pursuits. He worshiped Maa Kali for years for spiritual development and to get a Guru. Aughar Baba Ram, who was his cousin in the tradition of Baba Kinaram of the Aghor sect of Kashi, said, “You will get a Guru here in Kashi.” Thereafter, in the year 1984, before Guru Purnima, he received initiation from Shri Satyacharan Lahiri, the great grandson of Shri Lahiri Baba. As a result of his intense Kriya Yoga practice, he received all the six Kriyas from his Guru in just 2 years.
               
                </p>
            </div>
        </div>
        <div>
            <p className='main-head1'>
            <strong>Kriya Guru</strong>
            </p>
          </div>
          <div className="image-container2">
          <img src={Guruji} alt='Acharya Shri Dharmendra Ji Maharaj'/>
          </div>
          <div className='nme'>
            <p>
Acharya Shree Dharmendra Ji Maharaj</p>
          </div>
          <div className="para">
            <div className="style-p">
            <p className='head1'>
              <strong>Foremost preaching</strong>
              </p>
                <p className='other'>
                <strong>"Perfection is the name of Yogi"</strong>
                  
                </p>
            </div>
        </div>
        </div>
        )}
        <ContactUs/>
   
    </>
  )
}
